import { ChartPanel, LineChart } from "@/components/analytics";

interface LiftGainData {
  bin: number;
  gain: number;
  lift: number;
  cumulative_positives: number;
  [key: string]: unknown;
}

interface LiftGainVizProps {
  data: LiftGainData[];
}

export function LiftGainViz({ data }: LiftGainVizProps) {
  if (!data || data.length === 0) {
    return <p className="text-xs text-muted">No lift/gain data available.</p>;
  }

  return (
    <div className="grid grid-cols-2 gap-4">
      <ChartPanel title="Lift Chart">
        <LineChart
          data={data}
          xKey="bin"
          series={[{ dataKey: "lift", color: "accent" }]}
          height={400}
          referenceY={1.0}
        />
      </ChartPanel>

      <ChartPanel title="Gain Chart">
        <LineChart
          data={data}
          xKey="bin"
          series={[{ dataKey: "gain", color: "accent" }]}
          height={400}
        />
      </ChartPanel>
    </div>
  );
}
